import { AlertTriangle, Info, SearchX } from "lucide-react";
import { useLang } from "@/lib/i18n";

// Honest, non-inferring notices. `status` is one of:
//  - "none": source queried OK but returned zero records
//  - "unavailable": source could not be reached
//  - "not_connected": no official source for this category is connected yet
export const StatusNotice = ({ status, testid }) => {
  const { t } = useLang();
  const map = {
    none: { icon: SearchX, key: "notice.none", cls: "border-border bg-secondary/40 text-muted-foreground" },
    unavailable: { icon: AlertTriangle, key: "notice.unavailable", cls: "border-amber-500/40 bg-amber-500/5 text-amber-700 dark:text-amber-400" },
    not_connected: { icon: Info, key: "notice.notConnected", cls: "border-border bg-secondary/40 text-muted-foreground" },
  };
  const cfg = map[status] || map.none;
  const Icon = cfg.icon;
  return (
    <div data-testid={testid} className={`flex items-start gap-2.5 rounded-lg border p-3.5 text-sm ${cfg.cls}`}>
      <Icon className="mt-0.5 h-4 w-4 shrink-0" />
      <span>{t(cfg.key)}</span>
    </div>
  );
};
